<template>
  <div :class="['cotton-bot', isDialog ? 'cotton-bot-dialog' : '']">
    <div class="cotton-bot-nav">
      <img class="logo" src="https://bigdata.topeti.com/PCRepository/mainPlatform/cottonbotLogo.png" />
      <!-- 导航 -->
      <div v-for="(item, index) in navConfig"
        :class="['nav-item', navConfigActive === index ? 'nav-item-active' : '']"
        @click="navChange(index)"
        :key="item.value">
        <el-icon>
          <ChatDotSquare v-if="index === 0" />
          <Menu v-else />
        </el-icon>
      </div>
    </div>
    <div class="cotton-bot-main">
      <div class="cotton-bot-main-left">
        <!-- 搜索input -->
        <div class="search-input">
          <el-input v-model="searchInput" placeholder="请输入你的内容">
            <template #append>
              <el-icon><Search /></el-icon>
            </template>
          </el-input>
        </div>
        <!-- 默认添加 -->
        <div class="bot-list-main">
          <template v-for="list in isUserAddBot ? 2 : 1" :key="list">
            <div class="bot-title">
              <span>{{list === 1 ? '默认添加' : '我添加' }}的智能体</span>
              <span v-if="list === 2" class="add-bot-btn" @click="toSelectAi"><el-icon><CirclePlus /></el-icon>添加</span>
            </div>
            <div v-for="(item, index) in getUseRobot(list)"
              @click="robotChange(item, list)"
              :class="['bot-item', currentBot?.aiModelId === item.aiModelId ? 'bot-item-active' : '']"
              :key="index">
              <div class="bot-img">
                <img :src="item.imgUrl" />
                <div class="received-badge" v-if="progressBot.includes(item.aiModelId)">收到</div>
              </div>
              <div class="bot-info">
                <div class="bot-item-top">
                  <div class="bot-name" :title="item.name">{{ item.name }}</div>
                  <div class="bot-time">{{ getTimeFun(item.ctime) }}</div>
                </div>
                <div class="bot-item-bottom">
                  <div class="bot-tips">{{ item.description }}</div>
                  <div class="bot-state-icon"> 
                    <el-icon class="spin-icon" v-if="progressBot.includes(item.aiModelId)"><Loading /></el-icon>
                    <i v-else class="iconfont icon-wancheng"></i>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <!-- 任务中心logo -->
        <div class="task-center">
          <el-icon><Tickets /></el-icon>
          任务中心
        </div>
      </div>
      <div class="cotton-bot-main-right">
        <div class="cotton-bot-main-right-header">
          <span>Hi~我是CottonBot，很高兴为您服务</span>
          <el-button link type="primary" @click="close"><el-icon style="font-size: 20px;"><Close /></el-icon></el-button>
        </div>
        <div class="cotton-bot-main-right-content">
          <cottonBotTalk
            v-show="navConfigActive === 0"
            :aiBotList="[...aiBotList, ...selfRobotList]"
            :currentBot="currentBot"
            :cottonBotId="Number(robotId)"
            @changeGetData="changeGetData"
            @cancelSelectedBot="currentBot = null"
          />
          <cottonBotManage v-show="navConfigActive && currentBot" :botConfig="currentBot" :robotId="Number(robotId)" :isSelf="isSelfManage" @delBot="delSelfBot" @confirm="manageConfirm" />
        </div>
      </div>
    </div>
    <selectBot ref="selectBotRef" @confirm="selectBotConfirm" />
  </div>
</template>

<script setup>
  import { ref, defineProps, onBeforeMount, defineEmits } from 'vue'
  import cottonBotTalk from './components/cottonBotTalk'
  import cottonBotManage from './components/cottonBotManage'
  import selectBot from './components/selectBot'

  import { useRoute } from 'vue-router'
  import { getairobotbyid, getaiuserrobotlist, addaiuserrobot, updateaiuserrobot } from '@/port/clientSide/cottonBot.js'
  import { formatDate } from "@/api/global.js";
  // import { cloneDeep } from 'lodash';
  const router = useRoute()
  const props = defineProps({
    customDeskInfo: {
      type: Object,
      default: () => ({})
    },
    isDialog: {
      type: Boolean,
      default: false
    }
  })
  const navConfig = ref([
    { value: 'talk' },
    { value: 'manage' },
  ])
  const navConfigActive = ref(0)
  const currentBot = ref(null)
  // 导航的切换
  const navChange = (index) => {
    navConfigActive.value = index
    currentBot.value = null
  }

  // 机器人的切换
  const isSelfManage = ref(false)
  const robotChange = (item, index) => {
    if (currentBot.value?.aiModelId !== item.aiModelId) {
      currentBot.value = cloneDeep(item)
    } else {
      currentBot.value = null
    }
    isSelfManage.value = index === 2 ? true : false
  }

  const robotId = ref(null)
 
  const searchInput = ref('')
  const progressBot = ref([])
  // 改变是否在获取数据的状态
  const changeGetData = (val, matchBot) => {
    if (val) {
      progressBot.value = Array.isArray(matchBot) ? matchBot.map(item => { return typeof item === 'number' ? item : item.aiModelId }) : []
    } else {
      // 清除执行中的状态
      progressBot.value = Array.isArray(matchBot) ? progressBot.value.filter(item => {
        if (matchBot.includes(item)) {
          return false
        }
        return true
      }) : []
    }
  }
  // 判断是默认添加的还是自己添加的智能体
  const aiBotList = ref([])
  const getUseRobot = (index) => {
    const list = index === 1 ? aiBotList.value : selfRobotList.value
    return list.filter(item => {
      return item.name.search(searchInput.value) !== -1
    })
  }
  // 获取机器人配置
  const isUserAddBot = ref(false)
  import { getaimodellist } from '@/port/admins/ai'
  const getRobotInfo = async () => {
    const { code, data } = await getairobotbyid({ aiRobotId: robotId.value })
    if (code === 0) {
      const robotInfo = JSON.parse(data.robot)
      // 获取实时ai小易的配置信息
      const robotIds = robotInfo.botList.map(item => { return item.aiModelId })
      const { data: robotList } = await getaimodellist({ aiModelIds: robotIds.join(), curpage: 0,  pagesize: 0 })
      if (robotList?.length) {
        aiBotList.value = dealRobotList(robotList, robotInfo.botList)
      }
      isUserAddBot.value = robotInfo.isUserAddBot || false
    }
  }
  const dealRobotList = (robotList = [], oldRobotList = []) => {
    return robotList.map(item => { 
      const config = JSON.parse(item.config) 
      item.imgUrl = getImgUrl(config)
      item.name = item.appname

      const oldRobot = oldRobotList.find(iten => { return iten.aiModelId === item.aiModelId  })
      item.isAloneTalk = oldRobot?.isAloneTalk || false
      item.aloneTalkContent = oldRobot?.aloneTalkContent || ''
      return item
    })
  }
  import util from '@/api/util'
  import { cloneDeep } from 'lodash'
  const apiurls = util.apiUrl()
  const getImgUrl = (config) => {
    const defaultUrl = 'https://bigdata.topeti.com/PCRepository/mainPlatform/chat/s-enterprise-0.png';
    if (config?.agentConfig?.style) {
      if (config.agentConfig.style.avatarId) {
        return `https://bigdata.topeti.com/PCRepository/mainPlatform/chat/s-${config.agentConfig.style.avatarId}.png`;
      } else if (config.agentConfig.style.halfBodyImage) {
        return `${apiurls}/userfiles/${config.agentConfig.style.halfBodyImage}`;
      }
    }
    return defaultUrl;
  }

  const getTimeFun = (val) => {
    return !val ? '' : formatDate(new Date(val), 'hh:mm:ss')
  }

  const selectBotRef = ref(null)
  const toSelectAi = () => {
    selectBotRef.value.open([])
  }
  const selectBotConfirm = (val) => {
    const allRobotList = [...selfRobotList.value, ...aiBotList.value]
    const robotList = val.filter(item => {
      return allRobotList.findIndex(iten => { return iten.aiModelId === item.aiModelId }) === -1
    })
    if (robotList.length > 0) {
      selfRobotList.value.push(...dealRobotList(robotList, []))
      const config = JSON.stringify({ botList: selfRobotList.value })
      if (userRobotId.value) {
        // 修改
        updateSelfBot({ aiUserrobotId: userRobotId.value, config })
      } else {
        // 新增我添加的
        addaiuserrobot({ aiRobotId: robotId.value, config })
      }
    }
  }

  
  // 获取我添加的机器人
  const userRobotId = ref(null)
  const selfRobotList = ref([])

  const getSelfRobot = async () => {
    const { code, data } = await getaiuserrobotlist({ curpage: 0, pagesize: 0, aiRobotIds: robotId.value })
    if (code === 0 && data.length > 0) {
      const curData = data[0]
      userRobotId.value = curData.aiUserrobotId
      const { botList } = JSON.parse(curData.config)
      if (botList?.length > 0) {
        const botListId = botList.map(item => { return item.aiModelId })
        const { data } = await getaimodellist({ aiModelIds: botListId.join(), curpage: 0,  pagesize: 0 })
        selfRobotList.value = dealRobotList(data, [])
      } 
    }
  }

  // 删除我添加的机器人
  const delSelfBot = (val) => {
    const index = selfRobotList.value.findIndex(item => { return item.aiModelId === val.aiModelId })
    if (index !== -1) {
      selfRobotList.value.splice(index, 1)
      currentBot.value = null
      updateSelfBot({ aiUserrobotId: userRobotId.value, config: JSON.stringify({ botList: selfRobotList.value }) })
    }
  }

  // 管理的返回
  const manageConfirm = (val) => {
    const index = selfRobotList.value.findIndex(item => { return item.aiModelId === val.aiModelId })
    if (index !== -1) {
      selfRobotList.value[index] = val
      updateSelfBot({ aiUserrobotId: userRobotId.value, config: JSON.stringify({ botList: selfRobotList.value }) })
    }
  }

  // 修改个人添加的机器人
  const updateSelfBot = async (query) => {
    await updateaiuserrobot(query)
  }

  const emit = defineEmits(['close'])
  // 关闭弹窗
  const close = () => {
    emit('close')
  }

  onBeforeMount(() => {
    robotId.value = props.customDeskInfo.id || router.query?.id
    if (robotId.value) {
      getRobotInfo()
      getSelfRobot()
    }
  })
</script>
<script>
export default {
  name: 'cottonBot'
}
</script>

<style lang="scss" scoped>
  .cotton-bot {
    width: 100%;
    height: 100%;
    display: flex;
    &-nav {
      width: 60px;
      height: 100%;
      background-color: #F9F8FE;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-content: flex-start;
      
      .logo {
        margin: 10px 0 20px 0;
        width: 40px;
        height: 40px;
      }
      .nav-item {
        width: 32px;
        height: 34px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        box-sizing: border-box;
        color: #7E8182;
        cursor: pointer;
        border-radius: 8px;
        margin-bottom: 10px;
        i {
          font-size: 20px;
        }
      }
      .nav-item-active, .nav-item:hover {
        background-color: #EEEDF8;
        color:#4550DC;
      }
    }
    &-main {
      flex: 1;
      height: 100%;
      background-color: #F9F8FE;
      display: flex;

      &-left {
        width: 253px;
        padding: 18px 0px 20px 0px;
        height: 100%;
        box-sizing: border-box;
        border-right: 1px solid #D6DAE3;
        border-left: 1px solid #D6DAE3;
        .logo {
          margin-right: 10px;
        }
        .task-center {
          margin-top: 20px !important;
          box-sizing: border-box;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #FFF;
          border: 1px solid #F0F2F6;
          box-shadow: 0px 0px 2.4px 0px rgba(69, 80, 220, 0.1);
          border-radius: 27px;
          color: #4550DC;
          font-size: 16px;
          i {
            margin-right: 4px;
          }
        }
        .search-input, .bot-item, .task-center {
          margin: 0 10px;
        }
        .search-input {
          background: linear-gradient(#E3EEFF, #E3EEFF), /* 内容背景 */
          linear-gradient(45deg, rgba(185, 156, 255, 1), rgba(155, 206, 255, 1)); /* 边框背景 */
          background-clip: padding-box, border-box; /* 分别剪裁 */
          border: 1px solid transparent; /* 透明边框提供空间 */
          border-radius: 4px;
          
          :deep(.el-input) {
            background-color: #FFF;
          }
          :deep(.el-input), .search-input {
            border-radius: 4px;
          }
          :deep(.el-input-group__append) {
            padding: 0 10px;
            color: #6F5EFF;
            background: radial-gradient(
              circle at center,
              #e6deff 0%,
              #f8f7ff 100%
            );
            border-radius: 50%;
            border-color: #e6deff;
            box-shadow: none;
          }
          :deep(.el-input__wrapper) {
            box-shadow: none;
          }
        }
        .bot-list-main {
          height: calc(100% - 100px);
          overflow-y: auto;
          border-bottom: 1px solid #D6DAE3;
          .bot-title {
            font-size: 16px;
            line-height: 40px;
            position: relative;
            border-bottom: 1px solid #D6DAE3;
            padding: 0 10px;
            margin-top: 12px;
            .add-bot-btn {
              position: absolute;
              right: 10px;
              top: 8px;
              padding: 4px 10px;
              border-radius: 31px;
              background-color: #FFF;
              font-size: 12px;
              line-height: 1;
              color: #9E3CFF;
              cursor: pointer;
              .el-icon {
                position: relative;
                top: 2px;
                margin-right: 2px;
              }
            }
          }

          .bot-item {
            border-radius: 5px;
            background-color: #FFFFFF;
            display: flex;
            align-items: center;
            height: 66px;
            box-sizing: border-box;
            margin-top: 8px;
            cursor: pointer;
            .bot-img {
              width: 48px;
              height: 48px;
              position: relative;
              img {
                width: 100%;
                height: 100%;
              }
              /* "收到"气泡标签 */
              .received-badge {
                position: absolute;
                top: -12px;
                left: 50%;
                transform: translateX(-50%);
                background-color: #6C8AFF;
                color: white;
                width: 30px;
                padding: 2px 12px;
                border-radius: 8px;
                font-size: 14px;
                font-weight: bold;
                box-shadow: 0 2px 6px rgba(108, 138, 255, 0.4);
                &::before {
                  content: "";
                  position: absolute;
                  --size: 15px;
                  left: 0px;
                  top: 16px;
                  width: 0;
                  height: 0;
                  border-bottom: var(--size) solid transparent;
                  border-right: var(--size) solid #6C8AFF;
                }
              }
            }
            .bot-info {
              flex: 1;
              padding: 5px;
            }
            .bot-item-top, .bot-item-bottom {
              display: flex;
              justify-content: space-between;
            }
            .bot-item-top {
              .bot-name {
                font-weight: 600;
                width: 120px;
                white-space: nowrap;
                overflow: hidden; 
                text-overflow: ellipsis;
              }
              .bot-time {
                flex: 1;
                font-weight: 400;
                color: #5C5E65;
              }
            }
            .bot-item-bottom {
              margin-top: 5px;
              .bot-tips {
                color: #6D6E6F;
              }
              .bot-state-icon {
                color: rgb(64, 220, 134);
                /* 定义旋转动画 */
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
                .spin-icon {
                  animation: spin 1s linear infinite; /* 线性无限循环 */
                }
              }
            }
          }
          .bot-item:hover, .bot-item-active {
            background-color: #DAE3FF;
          }
        }
      }

      &-right {
        flex: 1;
        display: flex;
        flex-direction: column;
        background-color: #FFF;
        &-header {
          height: 50px;
          padding: 0 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
          span {
            color: #9D68FB;
            font-size: 16px;
          }
          border-bottom: 1px solid #D6DAE3;
        }
        &-content {
          flex: 1;
          height: calc(100% - 80%);
        }
      }
    }
  }

  .cotton-bot-dialog {
    .cotton-bot-nav {
      border-top-left-radius: 20px;
    }
    .cotton-bot-main-right, .cotton-bot-main {
      border-top-right-radius: 20px;
    }
  }
</style>